<template>
	<div class="chart-tooltip box">
		<div class="chart-tooltip__item col sm-16 md-4 lg-3">
			<p class="eyebrow">Name</p>
			<p class="p2 chart-tooltip__title">{{ fundName }}</p>
		</div>
		<template v-for="item in statList">
			<div
				v-if="!item.hideOnCurrent || period != '0'"
				:key="item.id"
				class="chart-tooltip__item col sm-16 md-4 lg-3"
			>
				<p class="eyebrow">{{ item.name }}</p>
				<p
					v-if="item.data1"
					class="p2 chart-tooltip__stat"
					:class="[
						{ 'chart-tooltip__stat--legend': item.legend },
						item.name === 'Date' ? 'date' : '',
						item.legend
					]"
				>
					{{ item.data1 }}
				</p>
				<p
					v-if="item.data2"
					class="p2 chart-tooltip__stat"
					:class="[item.name === 'Date' ? 'date' : '']"
				>
					{{ item.data2 }}
				</p>
			</div>
		</template>
	</div>
</template>

<script>
export default {
	name: "LineChartStats",
	props: ["statList", "fundName", "period"]
};
</script>

<style lang="scss">
.chart-tooltip {
	margin-bottom: 20px;
	padding: 25px 0 0 0;

	@include from-md {
		border-bottom: 2px solid $color--lighter-gray;
		margin-bottom: 0;
		padding: 32px 0 0 0;
	}

	.chart-tooltip__title {
		font-weight: $font-weight--bold;
		text-transform: uppercase;
	}

	.chart-tooltip__item {
		&:last-child {
			@include from-md {
				flex: 0 1 25%;
			}

			@include from-lg {
				flex: 0 1 12.5%;
			}
		}

		.p2 {
			margin-bottom: 0;

			@include from-md {
				font-size: 15px;
			}

			@include from-lg {
				font-size: 16px;
			}
		}

		.chart-tooltip__stat--legend {
			+ .chart-tooltip__stat {
				margin-left: 22px;
			}

			&::before {
				border-radius: 50%;
				content: "";
				display: inline-block;
				height: 14px;
				margin-right: 7px;
				position: relative;
				transform: translateY(1.4px);
				width: 14px;
			}

			&.turquoise::before {
				background-color: $color--turquoise;
			}

			&.almostBlack::before {
				background-color: $color--almost-black;
			}
		}

		@include from-md {
			margin-bottom: 23px;

			.chart-tooltip__separator {
				display: none;
			}
		}

		@include to-md {
			border-bottom: 1px solid $color--lighter-gray;
			border-top: 1px solid $color--lighter-gray;
			padding: 20px 0;

			&:first-child {
				border-top: none;
			}

			&:last-child {
				border-bottom: none;
			}

			.chart-tooltip__stat {
				&:last-child {
					display: none;
				}

				&.date {
					display: inline;
				}

				&--legend {
					&::before {
						display: none;
					}
				}
			}
		}
	}

	.chart-tooltip__stat {
		font-weight: $font-weight--light;
	}
}
</style>
